import Vue from 'vue';
import { addEventListener } from '@goodt-wcore/utils';

const ErrorEventType = {
    ERROR: 'error',
    UNHANDLEDREJECTION: 'unhandledrejection'
};

/**
 *
 * @param handle
 * @return {(function(): void)|*}
 */
const listenVueErrorHandler = (handle) => {
    Vue.config.errorHandler = (error, context, scope = 'component') => {
        handle({ error, context, scope });
    };
    return () => {
        Vue.config.errorHandler = null;
    };
};

/**
 *
 * @param handle
 * @return {(function(): void)|*}
 */
const listenUnhandled = (handle) => {
    const listener = (event) => {
        // eslint-disable-next-line no-restricted-syntax
        const {
            error = { name: 'Undefined reason', message: 'No message', stack: '', context: null, scope: 'global' }
        } = event;

        const { context, scope = 'global' } = error;
        handle({ error, context, scope });
    };
    return addEventListener(window, ErrorEventType.ERROR, listener);
};

/**
 *
 * @param handle
 * @return {(function(): void)|*}
 */
const listenUncaught = (handle) => {
    const listener = (event) => {
        // eslint-disable-next-line no-restricted-syntax
        const {
            reason: error = {
                name: 'Undefined reason',
                message: 'No message',
                stack: '',
                context: null,
                scope: 'Uncaught (in promise)'
            }
        } = event;
        const { context, scope = 'global' } = error;
        handle({ error, context, scope });
    };
    return addEventListener(window, ErrorEventType.UNHANDLEDREJECTION, listener);
};

export default [listenVueErrorHandler, listenUnhandled, listenUncaught];
